<template>
    <v-dialog v-model="show" max-width="800" persistent no-click-animation>
        <div class="AudioEngineConfigEditor">
            <div class="dialog-header">
                <div>{{ $f.tc('audioEngineConfigEditor') }}</div>
                <v-btn flat icon @click="closeDialog">
                    <v-icon>close</v-icon>
                </v-btn>
            </div>
            <div v-if="engineConfigs.input.length > 0" style="height: 353px; overflow-y: auto;"
                 class="fci-scrollbar p-12">
                <SimpleDataTable
                    table-title="Input"
                    :headers="headers"
                    :items="input"
                    :hide-pager="true">
                    <template v-slot:key="props">
                        {{ props.item.key }}
                    </template>
                    <template v-slot:description="props">
                        <v-autocomplete
                            v-if="props.item.index === editInput.config.index && inputDropDown['value'][props.item.key].length > 0"
                            :rows="2"
                            v-model="editInput.config.value"
                            class="input-edit"
                            :items="inputDropDown['value'][props.item.key]"
                        ></v-autocomplete>
                        <v-text-field
                            v-else-if="props.item.index === editInput.config.index && inputDropDown['value'][props.item.key].length === 0"
                            :rows="2"
                            v-model="editInput.config.value"
                            class="input-edit">
                        </v-text-field>
                        <div v-else>
                            {{ props.item.value }}
                        </div>
                    </template>
                    <template v-slot:action="props">
                        <div v-if="editInput.show && props.item.index === editInput.config.index" class="centerXY">
                            <div class="btn-icon mr-6" @click="closeEdit('input')"
                                 style="margin: 0!important">
                                <img src="/img/close.svg" alt="icon-config"
                                     style="transform: scale(1.1)">
                            </div>
                            <div class="btn-icon" @click="saveEdit(props.item, 'input')"
                                 style="margin: 0!important">
                                <img src="/img/save-member-2.svg" alt="icon-config"
                                     style="transform: scale(0.9)">
                            </div>
                        </div>
                        <div v-else class="centerXY">
                            <div class="btn-icon" @click="editConfig(props.item, 'input')"
                                 style="margin: 0!important">
                                <img src="/img/edit.svg" alt="icon-edit"
                                     style="transform: scale(0.9); padding-left: 1px">
                            </div>
                            <div
                                v-if="inputDropDown['value'][props.item.key].length === 0"
                                class="btn-icon"
                                @click="deleteConfig(props.item, 'input')"
                                style="margin: 0!important">
                                <img src="/img/delete-member.svg" alt="icon-delete"
                                     style="transform: scale(0.9); padding-left: 1px">
                            </div>
                        </div>
                    </template>
                </SimpleDataTable>
                <div
                    class="btn-custom-normal btn-add"
                    @click="handleClickAdd('input')"
                    v-show="!isShowAddInput && input.length !== engineConfigs.input.length"
                >
                    <img src="/img/add-member.svg" alt="icon-add" style="padding-right: 6px">
                    {{ $f.tc('addNew') }}
                </div>
                <v-form v-show="isShowAddInput" class="table-add-member" v-model="formValid" ref="form">
                    <div class="item-new-member">
                        <v-autocomplete
                            v-model="newInput.key"
                            :rules="formRules.required"
                            class="input-custom"
                            :items="inputDropDown['key']"
                        ></v-autocomplete>
                    </div>
                    <div class="item-new-member">
                        <v-combobox
                            ref="NewInputConfigValue"
                            v-model="newInput.value"
                            :rules="formRules.required"
                            class="input-custom"
                            :items="inputDropDown['value'][newInput.key]"
                            :rows="2"
                        >
                        </v-combobox>
                    </div>
                    <div class="item-new-member centerXY">
                        <div @click="cancelAddConfig('input')" class="btn-icon">
                            <img src="/img/close.svg" alt="icon-config" style="transform: scale(1.3)">
                        </div>
                        <div @click="submit($event, 'input')" class="btn-icon">
                            <img src="/img/save-member-2.svg" alt="icon-save" style="transform: scale(0.9);">
                        </div>
                    </div>
                </v-form>
            </div>

            <!-- OUTPUT -->
            <div style="padding: 0 12px 12px 12px">
                <div style="height: 353px; overflow-y: auto; padding-top:12px;" class="fci-scrollbar">
                    <SimpleDataTable
                        table-title="Output"
                        :headers="headers"
                        :items="output"
                        :hide-pager="true"
                    >
                        <template v-slot:key="props">
                            <v-text-field
                                v-if="props.item.index === editOutput.config.index"
                                :rows="2"
                                :rules="formRules.required"
                                v-model="editOutput.config.key"
                                class="input-edit"
                            ></v-text-field>
                            <div v-else>
                                {{ props.item.key }}
                            </div>
                        </template>
                        <template v-slot:description="props">
                            <v-autocomplete
                                v-if="props.item.index === editOutput.config.index"
                                :rows="2"
                                v-model="editOutput.config.value"
                                class="input-edit"
                                :items="outputDropDown"
                            ></v-autocomplete>
                            <div v-else>
                                {{ props.item.value }}
                            </div>
                        </template>
                        <template v-slot:action="props">
                            <div v-if="editOutput.show && props.item.index === editOutput.config.index"
                                 class="centerXY">
                                <div class="btn-icon mr-6" @click="closeEdit('output')"
                                     style="margin: 0!important">
                                    <img src="/img/close.svg" alt="icon-config"
                                         style="transform: scale(1.1)">
                                </div>
                                <div class="btn-icon" @click="saveEdit(props.item, 'output')"
                                     style="margin: 0!important">
                                    <img src="/img/save-member-2.svg" alt="icon-config"
                                         style="transform: scale(0.9)">
                                </div>
                            </div>
                            <div v-else class="centerXY">
                                <div class="btn-icon" @click="editConfig(props.item, 'output')"
                                     style="margin: 0!important">
                                    <img src="/img/edit.svg" alt="icon-edit"
                                         style="transform: scale(0.9); padding-left: 1px">
                                </div>
                                <div class="btn-icon" @click="deleteConfig(props.item, 'output')"
                                     style="margin: 0!important">
                                    <img src="/img/delete-member.svg" alt="icon-delete"
                                         style="transform: scale(0.9); padding-left: 1px">
                                </div>
                            </div>
                        </template>
                    </SimpleDataTable>
                    <div
                        class="btn-custom-normal btn-add"
                        @click="handleClickAdd('output')"
                        v-show="!isShowAddOutput"
                    >
                        <img src="/img/add-member.svg" alt="icon-add" style="padding-right: 6px">
                        {{ $f.tc('addNew') }}
                    </div>
                    <v-form v-show="isShowAddOutput" class="table-add-member" v-model="formValid" ref="form">
                        <div class="item-new-member">
                            <v-text-field
                                v-model="newOutput.key"
                                :rules="formRules.required"
                                class="input-custom"
                                ref="NewOutputConfigKey"
                            ></v-text-field>
                        </div>
                        <div class="item-new-member">
                            <v-autocomplete
                                v-model="newOutput.value"
                                :rules="formRules.required"
                                class="input-custom"
                                :items="outputDropDown"
                                :rows="2"
                            ></v-autocomplete>
                        </div>
                        <div class="item-new-member centerXY">
                            <div @click="cancelAddConfig('output')" class="btn-icon">
                                <img src="/img/close.svg" alt="icon-config" style="transform: scale(1.3)">
                            </div>
                            <div @click="submit($event, 'output')" class="btn-icon">
                                <img src="/img/save-member-2.svg" alt="icon-save" style="transform: scale(0.9);">
                            </div>
                        </div>
                    </v-form>
                </div>
            </div>
        </div>
    </v-dialog>
</template>


<script>
import DialogPromiseFormMixin from "@/modules/fptai/mixins/DialogPromiseFormMixin";
import SimpleDataTable from '@/components/SimpleDataTable'
import lodash from "lodash";

const defaultConfig = {
    key: '',
    value: ''
}

const defaultEngineConfig = {
    input: [],
    output: []
}

const defaultDropDown = {
    key: [],
    value: {}
}

const defaultEditConfig = {
    index: -1,
    config: {},
    show: false,
}

export default {
    name: "AudioEngineConfigEditor",
    components: {SimpleDataTable},
    mixins: [DialogPromiseFormMixin],
    computed: {
        headers() {
            return [
                {
                    text: this.$f.tc('key'),
                    value: 'key',
                    type: 'custom',
                    id: 'key'
                },
                {
                    text: this.$f.tc('value'),
                    value: 'value',
                    type: 'custom',
                    id: 'description'
                },
                {
                    text: '',
                    value: 'action',
                    sortable: false,
                    type: 'custom',
                    id: 'action'
                }
            ]
        }
    },
    data() {
        return {
            output: [],
            input: [],
            isShowAddOutput: false,
            isShowAddInput: false,
            newOutput: this.$utils.cloneObject(defaultConfig),
            newInput: this.$utils.cloneObject(defaultConfig),
            editOutput: this.$utils.cloneObject(defaultEditConfig),
            editInput: this.$utils.cloneObject(defaultEditConfig),
            engineConfigs: this.$utils.cloneObject(defaultEngineConfig),
            engine: "",
            inputDropDown: this.$utils.cloneObject(defaultDropDown),
            outputDropDown: [],
        }
    },
    methods: {
        open(item, engine) {
            this.convertConfig(item)
            // this.clearForm()
            this.engine = engine.key
            this.engineConfigs = {"input": engine.input, "output": engine.output}
            this.getDropDown(engine)
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {resolve, reject}
            })
        },
        convertConfig(item) {
            let outputKeys = Object.keys(item["output"])
            outputKeys.forEach((key, index) => {
                const found = this.output.some(el => el.key === key)
                if (!found) {
                    this.output.push({
                        index: index,
                        key: key,
                        value: item["output"][key]
                    })
                }
            })

            let inputKeys = Object.keys(item["input"])
            inputKeys.forEach((key, index) => {
                const found = this.input.some(el => el.key === key)
                if (!found) {
                    this.input.push({
                        index: index,
                        key: key,
                        value: item["input"][key]
                    })
                }
            })
        },
        getDropDown(config) {
            this.inputDropDown = this.$utils.cloneObject(defaultDropDown)
            this.outputDropDown = []
            config.input.forEach(i => {
                let found = this.input.some((e) => e.key === i.key)
                if (!found) {
                    this.inputDropDown['key'].push(i.key)
                }
                this.inputDropDown["value"][i.key] = i.value
            })
            config.output.forEach(i => {
                this.outputDropDown.push(i.value)
            })
        },
        handleClickAdd(typeTable) {
            if (typeTable === 'output') {
                this.isShowAddOutput = true
                this.$nextTick(() => {
                    this.$refs.NewOutputConfigKey.focus()
                })
                return
            }
            this.isShowAddInput = true
            this.$nextTick(() => {
                this.$refs.NewInputConfigValue.focus()
            })
        },
        cancelAddConfig(typeTable) {
            if (typeTable === 'output') {
                this.isShowAddOutput = false
                this.$refs.form.resetValidation()
                this.newOutput = this.$utils.cloneObject(defaultConfig)
                return
            }
            this.isShowAddInput = false
            this.$refs.form.resetValidation()
            this.newInput = this.$utils.cloneObject(defaultConfig)
        },
        submit(event, typeTable) {
            if (typeTable === 'input') {
                this.$refs.NewInputConfigValue.blur()
            }
            this.$nextTick(() => {
                if (event) {
                    event.preventDefault()
                }
                if (this.formValid) {
                    this.submitValidForm(typeTable)
                } else if (this.$refs.form) {
                    this.$refs.form.validate()
                }
            })

        },
        submitValidForm(typeTable) {
            this.addConfig(typeTable)
        },
        addConfig(typeTable) {
            this.$appService.showLoading()
            if (typeTable === 'output') {
                this.output.push({
                    index: this.output.length,
                    key: this.newOutput.key,
                    value: this.newOutput.value
                })
            } else {
                this.input.push({
                    index: this.input.length,
                    key: this.newInput.key,
                    value: this.newInput.value
                })
            }
            this.saveConfig()
            if (typeTable === 'output') {
                this.isShowAddOutput = false
                this.newOutput = this.$utils.cloneObject(defaultConfig)
            } else {
                this.isShowAddInput = false
                this.newInput = this.$utils.cloneObject(defaultConfig)
            }
            this.$refs.form.reset()
            this.$appService.hideLoading()
        },
        editConfig(item, typeTable) {
            if (typeTable === 'output') {
                if (this.editOutput.show && this.editOutput.index > -1) {
                    this.$appService.toastError("currently editing a different key")
                    return
                }
                this.editOutput.show = true
                this.editOutput.index = this.output.indexOf(item)
                this.editOutput.config = this.$utils.cloneObject(item)
                return
            }

            if (this.editInput.show && this.editInput.index > -1) {
                this.$appService.toastError("currently editing a different key")
                return
            }

            this.editInput.show = true
            this.editInput.index = this.input.indexOf(item)
            this.editInput.config = this.$utils.cloneObject(item)
        },
        closeEdit(typeTable) {
            if (typeTable === 'output') {
                this.editOutput.index = -1
                this.editOutput.config = {}
                return
            }
            this.editInput.index = -1
            this.editInput.config = {}
        },
        saveEdit(item, typeTable) {
            if (typeTable === 'output') {
                if (lodash.isEqual(this.editOutput.config, item)) {
                    this.closeEdit(typeTable)
                    return
                }
                this.output.splice(this.editOutput.index, 1, this.editOutput.config)
                this.saveConfig()
                this.closeEdit(typeTable)
                return
            }

            if (lodash.isEqual(this.editInput.config, item)) {
                this.closeEdit()
                return
            }
            this.input.splice(this.editInput.index, 1, this.editInput.config)
            this.saveConfig()
            this.closeEdit(typeTable)
        },
        deleteConfig(item, typeTable) {
            let deleteMessage = this.$f.tc('delete') + ' ' + this.$t('config') + ' ' + item.key
            this.$appService.confirm(deleteMessage).then(
                confirm => {
                    if (confirm) {
                        if (typeTable === 'output') {
                            let indexToDelete = this.output.findIndex(config => config.key === item.key)
                            if (indexToDelete > -1) {
                                this.output.splice(indexToDelete, 1)
                            }
                            return
                        }
                        let indexToDelete = this.input.findIndex(config => config.key === item.key)
                        if (indexToDelete > -1) {
                            this.input.splice(indexToDelete, 1)
                        }
                    }
                }
            ).finally(
                this.saveConfig
            )
        },
        resetConfig() {
            this.output = []
            this.input = []
            this.newOutput = this.$utils.cloneObject(defaultConfig)
            this.newInput = this.$utils.cloneObject(defaultConfig)
            this.editOutput = {
                index: -1,
                config: {},
                show: false,
            }
            this.editInput = {
                index: -1,
                config: {},
                show: false,
            }
            this.engineConfigs = this.$utils.cloneObject(defaultEngineConfig)
            this.engine = ""
            this.inputDropDown = this.$utils.cloneObject(defaultDropDown)
            this.outputDropDown = []
        },
        closeDialog() {
            this.resetConfig()
            this.close()
        },
        saveConfig() {
            let result = {
                key: this.engine,
                config: {
                    input: {},
                    output: {}
                }
            }
            this.input.forEach(i => result.config.input[i.key] = i.value)
            this.output.forEach(i => result.config.output[i.key] = i.value)
            this.$forceUpdate()
            this.$emit('updateConfig', result)
            this.getDropDown(this.engineConfigs)
        }
    }
}
</script>

<style scoped lang="scss">
.AudioEngineConfigEditor {
    background: #FFFFFF;
    position: relative;
    overflow: hidden;

    .dialog-header {
        padding: 0 0 0 12px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi", serif;
        font-size: 13px;
    }

    .btn-custom-normal {
        height: 40px !important;
        border-radius: 0 !important;
        justify-content: left;
        color: #0052CC;
        font-size: 14px;
        font-family: "open sans bold", serif;
        font-style: normal;
        text-align: center;
    }
}

.textarea-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 0;
            outline: none;
            font-size: 12px;
            margin: 0;
            padding: 0 !important;
            display: flex;
            align-items: center;
            position: relative;

            textarea {
                padding: 15px 0 6px 0;
                overflow-y: auto;
                height: 50px;
                margin: 0 !important;
                color: black;
            }

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

.input-custom {
    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 0;
            border: none !important;
            outline: none;
            font-size: 14px;
            padding: 2px;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }

    }
}

.input-edit {
    ::v-deep {
        .v-input__slot {
            background: #FFFFFF;
            border-radius: 0;
            border: none !important;
            outline: none;
            font-size: 14px;
            display: flex;
            align-items: center;
            margin: 0 !important;

            &:before, &:after {
                border: none !important;
            }
        }

        input {
            padding-bottom: 7px !important;
        }
    }
}

.btn-add {
    height: 49px !important;
    border-radius: 0 !important;
    justify-content: left;
    color: #0052CC;
    font-size: 14px;
    font-family: "open sans bold", serif;
    font-style: normal;
    text-align: center;
    border-top: none;
}

.table-add-member {
    border: 1px solid #DADFEC;
    border-top: none;
    display: flex;

    .item-new-member {
        height: 40px;
        border-left: 1px solid #DADFEC;
        padding: 0 10px;
        display: flex;
        align-items: center !important;

        &:first-child {
            border-left: none;
        }

        &:nth-child(1) {
            position: relative;
            margin: 0 !important;
            width: 199px;
        }

        &:nth-child(2) {
            margin: 0 !important;
            width: 500px;
        }

        &:nth-child(3) {
            flex: 1;
            margin: 0 !important;
            text-align: center;
            padding: 0 !important;
        }
    }
}

::v-deep {
    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 10px !important;
        top: 18px !important;
    }

    .v-select {
        .v-text-field__details {
            right: 40px !important;
        }
    }

    .v-table__overflow {
        width: 100%;
        font-size: 14px;
        font-family: "open sans", serif !important;
        border: 1px solid #DADFEC;
        border-collapse: collapse;
        border-spacing: 0;

        thead tr:not(.v-datatable__progress) {
            height: 40px !important;
            border-bottom: none;
            padding: 0 !important;

        }

        thead tr th {
            text-transform: capitalize !important;
            color: #12274F !important;
            background: #F4F7FE;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 200px;
            }

            &:nth-child(2) {
                width: 500px;
            }

            &:nth-child(3) {
                flex: 1;
            }
        }

        tbody tr td {
            height: 40px !important;
            border-right: 1px solid #DADFEC;
            padding: 0 10px;
            border-top: 1px solid #DADFEC;

            &:last-child {
                border-right: none;
            }

            &:nth-child(1) {
                width: 200px;
            }

            &:nth-child(2) {
                width: 500px;
                max-width: 200px !important;
            }

            &:nth-child(3) {
                flex: 1;
                padding: 0;
            }

            &:nth-child(4), &:nth-child(5), &:nth-child(6) {
                align-items: center;
                justify-content: center;
                width: 100px;
            }
        }
    }

    .theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {
        background: #FFFFFF;
    }

    textarea {
        padding: 10px !important;
        overflow-y: auto;
        margin: 0 !important;
        font-size: 14px;

        &::-webkit-scrollbar {
            width: 7px;
            height: 10px;
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.1);
            border: none;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.5);
        }
    }

    select {
        padding: 10px !important;
        overflow-y: auto;
        margin: 0 !important;
        font-size: 14px;

        &::-webkit-scrollbar {
            width: 7px;
            height: 10px;
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-track {
            background-color: transparent;
            border: none;
        }

        &::-webkit-scrollbar-thumb {
            border-radius: 10px;
            background: rgba(0, 0, 0, 0.1);
            border: none;
        }

        &::-webkit-scrollbar-thumb:hover {
            background: rgba(0, 0, 0, 0.5);
        }
    }
}
</style>
